export enum AutomationFeature {
    REPLY_TO_REVIEW = 'REPLY_TO_REVIEW',
    INTELLIGENT_SUBJECT = 'INTELLIGENT_SUBJECT',
}

// REVIEW_REPLY_AUTOMATION

export enum ReviewReplyAutomationRatingCategory {
    REVIEW_1_2 = 'REVIEW_1_2',
    REVIEW_3 = 'REVIEW_3',
    REVIEW_4 = 'REVIEW_4',
    REVIEW_5 = 'REVIEW_5',
}

export enum ReviewReplyAutomationMethod {
    AI = 'AI',
    TEMPLATES = 'TEMPLATES',
}

export enum ReviewReplyAutomationComment {
    WITH_COMMENT = 'WITH_COMMENT',
    WITHOUT_COMMENT = 'WITHOUT_COMMENT',
}

export type RatingCategory = 1 | 2 | 3 | 4 | 5;

export const AUTO_REPLY_MAX_FAILED_ATTEMPTS = 5;
export const RETRY_REPLY_MAX_FAILED_ATTEMPTS = 10;
export const AUTO_REPLY_GENERATE_MAX_FAILED_ATTEMPTS = 2;

// INTELLIGENT_SUBJECT

export enum IntelligentSubjectAutomationAction {
    SEND_EMAIL = 'SEND_EMAIL',
}

export enum IntelligentSubjectAutomationRelatedEntity {
    REVIEWS = 'REVIEWS',
}

export enum IntelligentSubjectName {
    HYGIENE = 'hygiene',
    DISCRIMINATION = 'discrimination',
}

export const REVIEWS_INTELLIGENT_SUBJECTS_TO_DETECT = [IntelligentSubjectName.DISCRIMINATION, IntelligentSubjectName.HYGIENE];

/**
 * Global floor bounding AI risk-topic detection cost only.
 * It does NOT gate email sending — the risk-topic email is gated per automation
 * by the automation activation date (see ReviewsIntelligentSubjectActionHandlerService).
 */
export const INTELLIGENT_SUBJECTS_DETECTION_FLOOR_DATE = new Date('2025-10-01');
